import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container } from './ui';

const StyledImagesGrid = styled.section`
  ${sectionMargins()};
`;

const StyledGrid = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.medium`
    grid-template-columns: 1.4fr 1fr;
  `}
`;

const StyledImage = styled(GatsbyImage)`
  &:nth-child(3n + 1) {
    ${minBreakpointQuery.medium`
      grid-row: span 2;
    `}
  }
`;

const ImagesGrid = ({ images }) => (
  <StyledImagesGrid>
    <Container>
      <StyledGrid>
        {images.map(({ gatsbyImageData, alt }) => (
          <StyledImage image={gatsbyImageData} alt={alt} />
        ))}
      </StyledGrid>
    </Container>
  </StyledImagesGrid>
);

export default ImagesGrid;
